// // /////////////////////////////////////////////////////////////////////////////////////
// //                              Copyright (c) 2020 - 2025
// //                                    RXO Inc.
// //                          All Rights Reserved Worldwide
// //
// // WARNING:  This program (or document) is unpublished, proprietary
// // property of RXO Inc. and is to be maintained in strict confidence.
// // Unauthorized reproduction, distribution or disclosure of this program
// // (or document), or any program (or document) derived from it is
// // prohibited by State and Federal law, and by local law outside of the U.S.
// // /////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";

import { getFeatureFlags } from "../api/featureFlags";
import { featureFlagTypes } from "../helpers/types";

export const initialState = {
  isFailure: false,
  isFetching: false,
};

const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    requestFeatureFlags: state => {
      state.isFetching = true;
    },
    receiveFeatureFlagsSuccess: (state, { payload: { featureFlags } }) => {
      featureFlagTypes.forEach(({ key, name }) => {
        const toggle = featureFlags.find(t => t.name === name);
        if (toggle) {
          state[key] = toggle.enabled;
        }
      });

      state.isFetching = false;
    },
    receiveFeatureFlagsFailure: state => {
      state.isFailure = true;
      state.isFetching = false;
    }
  }
});

export const {
  requestFeatureFlags,
  receiveFeatureFlagsSuccess,
  receiveFeatureFlagsFailure
} = featureFlagsSlice.actions;

export const featureFlagsReducer = featureFlagsSlice.reducer;

export const fetchFeatureFlags = () => async dispatch => {
  dispatch(requestFeatureFlags());
  try {
    const toggles = (
      await getFeatureFlags(featureFlagTypes.map(({ name }) => name))
    ).data;

    dispatch(receiveFeatureFlagsSuccess(toggles));
  } catch {
    dispatch(receiveFeatureFlagsFailure());
  }
};
